import {Header} from "./Header";
import {Tabs} from "./Tabs";
import {Footer} from "./Footer";
import {useAPIData} from "../context/hooks/useAPIData";
import {useEffect} from "react";
import {initialize} from "../context/actions/userActions";
import {Modal} from "./Modal";
import {Popup} from "./Popup";
import {SET_AGENT} from '../context/actions/types'
import {isPrincessAgent} from '../helpers/functions'

export const Homepage = () => {
    const data = useAPIData()

    useEffect(() => {
        initialize(data.dispatch).then(r => r)
        data.dispatch({
            type: SET_AGENT,
            payload: isPrincessAgent()
        })
    }, [])

    return (
        <div>
            <Header />

            <Tabs races={data.activeRaces}/>

            <Modal />

            <Popup />

            <Footer isPrincessAgent={data.princessAgent}/>
        </div>
    )
}
